module.exports = __webpack_public_path__ + "static/media/README.01ac5d9f.md";